import { CheckCircleTwoTone, CloseCircleTwoTone, MailTwoTone, MinusCircleTwoTone, SyncOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";

const STATUS_CONFIG = {
    // Email verification is deferred to an asynchronous job after a bulk upload; this is
    // the placeholder state shown until that job resolves the real status.
    verification_pending: {
        icon: <SyncOutlined spin style={{ color: "#1890ff" }} />,
        label: "Email verification in progress",
    },
    // SES delivery tracking statuses
    consent_email_delivered: {
        icon: <CheckCircleTwoTone twoToneColor="#78d11f" />,
        label: "Consent email delivered successfully",
    },
    consent_email_bounced: {
        icon: <CloseCircleTwoTone twoToneColor="#ff4d4f" />,
        label: "Consent email bounced (permanent failure)",
    },
    consent_email_temporary_bounce: {
        icon: <MinusCircleTwoTone twoToneColor="#faad14" />,
        label: "Consent email temporarily bounced",
    },
    consent_email_complaint: {
        icon: <CloseCircleTwoTone twoToneColor="#ff4d4f" />,
        label: "Consent email marked as spam by recipient",
    },
    // Domain verification statuses
    domain_reachable: {
        icon: <CheckCircleTwoTone twoToneColor="#78d11f" />,
        label: "Email domain is reachable (can receive mail)",
    },
    mx_ok_smtp_reachable: {
        icon: <CheckCircleTwoTone twoToneColor="#78d11f" />,
        label: "Email domain verified",
    },
    mx_ok_smtp_unreachable: {
        icon: <MinusCircleTwoTone twoToneColor="#faad14" />,
        label: "Email domain found but mail server unreachable",
    },
    // Default provider path (deep mailbox check disabled): MX resolved successfully,
    // deep SMTP/Kickbox verification intentionally skipped. The domain can receive mail.
    mx_ok_smtp_skipped: {
        icon: <CheckCircleTwoTone twoToneColor="#78d11f" />,
        label: "Email domain verified (mail server present)",
    },
    no_mx: {
        icon: <CloseCircleTwoTone twoToneColor="#ff4d4f" />,
        label: "No mail server found for this domain",
    },
    dns_error: {
        icon: <CloseCircleTwoTone twoToneColor="#ff4d4f" />,
        label: "DNS lookup failed for email domain",
    },
    invalid_format: {
        icon: <CloseCircleTwoTone twoToneColor="#ff4d4f" />,
        label: "Invalid email format",
    },
};

const DEFAULT_CONFIG = {
    icon: <MailTwoTone twoToneColor="#aeb0ac" />,
    label: "Email not verified",
};

/**
 * Displays a small icon badge indicating the email domain verification status.
 * @param {{ verificationResult: IEmailVerificationResult | undefined }} props
 */
const EmailVerificationBadge = ({ verificationResult }) => {
    if (!verificationResult) {
        return null;
    }

    const config = STATUS_CONFIG[verificationResult.status] || DEFAULT_CONFIG;
    const domainInfo = verificationResult.domain ? ` (${verificationResult.domain})` : "";

    return (
        <Tooltip title={`${config.label}${domainInfo}`}>
            <span style={{ marginLeft: 4, cursor: "help" }}>{config.icon}</span>
        </Tooltip>
    );
};

export default EmailVerificationBadge;
